/**
 * @file:
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/9/4      1.0     First version
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {PureComponent,Fragment} from "react";
import {Alert, Drawer,Spin,message,Popconfirm} from 'antd';
import Lang from "@/components/Lang/Lang";
import { toFixedWithCommas} from "@utils/number-util";
import {getIntlYYMMDD,isEmpty,symbolMoneyUtil,toFixed2} from '@utils/utils';
import LogisticsInformation from '@components/Logistics/LogisticsInformation';
import AuthBtn from "@components/HoverIcon/AuthBtn";
// import ModalOrderDetail from "@components/ModalOrderDetails/ModalOrderDetail";
import AutoFetchList from '@components/AutoFetchList/AutoFetchList';
import DopIndexAction from "../../dopIndex.action"
import "./paymentCollectionDrawer.less";
export default class PaymentCollectionDrawer extends PureComponent {
    static defaultProps = {
        type: "", // 显示 1:定金 * 2:尾款 * 3:提货
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
    }
    /**
     * 抽屜
     * */
    showDrawer = (flag=true) => {
        if(this.props.showDrawer){ // 打开抽屉后回调
            this.props.showDrawer(flag)
        }
        this.setState({
            visible: flag,
        });

    }
    renderOne(buyerModel,inx){
        const {type} = this.props;
        const sCountryUrl =buyerModel.abbreviate?require('../../../../assets/img/country/'+buyerModel.abbreviate + '.png'):"";
        return (<div className={"showList black89 font_14 lineH_21"} key={buyerModel.id+"_a"+inx}>
            <div className={"flex-item-between mb_12"}>
                <div className={""}>
                    <div className={"flex-item-ver-center lineH_27"}>
                        {buyerModel.abbreviate?<img className="mr_4" src={sCountryUrl.default} width={24} />:null}
                        <span className={"fw_700 font_18"}>{buyerModel.buyerCode||"-"}</span>
                    </div>
                    <div className={"black45 lineH_21"}>{buyerModel.buyerName}</div>
                </div>
                <span className={"flex-item-ver-center"}>
                                            <i className={"ri-phone-fill black45 mr_4 font_20"} />
                                            <span className={"fw_700 font_16 lineH_24"}> +{buyerModel.telCode||"-"} {buyerModel.mobile||"-"}</span>
                                        </span>
            </div>
            {buyerModel.containerVOList&&buyerModel.containerVOList.length>0&&buyerModel.containerVOList.map((poModel,index)=>{
                let taskIds = []
                return (<div className={"subBox"}>
                    {poModel.poVOList&&poModel.poVOList.length>0&&poModel.poVOList.map((poItem,subIndex)=>{
                        taskIds.push(poItem.taskId)
                        return this.renderPoItem(poItem,subIndex)
                    })}
                    {/* 统计信息*/}
                    <div className={"lineGrey"}></div>
                    <div className={"flex-item-between"}>
                        <div>
                            {type==1?<span>{Lang({id:"ZongJinE",default:"总金额",})} {symbolMoneyUtil(poModel.totalPrice,poModel.currencySymbol)} </span>:<div>
                                <div>{Lang({id: 'GuiHao',default:'柜号'})}：{poModel.containerCode||"-"}</div>
                                <div>{Lang({id: 'RuKuShiJian', default: '入库时间'})}：{poModel.inStorageTime?getIntlYYMMDD(poModel.inStorageTime):"-"}</div>
                            </div>}
                        </div>
                        <div className={"flex-item-ver-center"}>
                            {type==1?<span className={"color_FB7321 fw_700 font_16"}>{Lang({id:"HeJiDingJin",default:"合计定金",})}
                               <span className={"ml_4"}>{symbolMoneyUtil(poModel.totalDeposit,poModel.currencySymbol)}</span>
                            </span>:
                            <span className={"color_FB7321 fw_700 font_16"}>{Lang({id:"HeJiWeiKuan",default:"合计尾款",})}
                                <span className={"ml_4"}>{symbolMoneyUtil(poModel.totalBalance,poModel.currencySymbol)}</span>
                            </span>}
                            <div className={"ml_8"}>
                                {/* 定金||尾款 且有付款凭证的  &&record.invoiceFileUrl*/}
                                {poModel.invoiceFileUrl&&<AuthBtn icon={"ri-file-text-line"}
                                                                  tips = {Lang({id:"FuKuanPingZheng",default:"付款凭证"})}
                                                                  onClick={()=>window.open(poModel.invoiceFileUrl,'_blank')}/>}
                                {/* 定金 没有物流按钮 */}
                                {type!=1?<LogisticsInformation showSimpleIcon={true} poId={poModel.poId}>
                                    {/*<span className={"btnWhite ml_8"}>{Lang({id:"WuLiu",default:"物流",})}</span>*/}
                                    <AuthBtn icon={"ri-truck-line"}
                                             className={"ml_8"}
                                             tips = {Lang({id:"WuLiu",default:"物流"})}
                                    />
                                </LogisticsInformation>:null}
                                {/*<ModalOrderDetail id={poModel.poId}>*/}
                                    {/*<span className={"btnWhite ml_8"}>{Lang({id:"XiangQing",default:"详情",})}</span>*/}
                                {/*</ModalOrderDetail>*/}
                            </div>
                            <Popconfirm placement="topRight"
                                        title={Lang({id: "QueRenYiLianXiGuo",default: "确认已联系过？"})}
                                        onConfirm={()=>this.contacted(taskIds)}
                                        okText={Lang({id:'queren',default:'确认'})}
                                        cancelText={Lang({id:'QuXiao',default:'取消'})}>
                                <span className={"ml_8 btnBlueContact"}>{Lang({id:"YiLianXiGuo2",default:"已联系过",})}</span>
                            </Popconfirm>
                        </div>
                    </div>

                </div>)}
                )}
        </div>)
    }
    renderPoItem(poItem={},subIndex){
        return (<div className={"subItem"} key={poItem.id+"_s"+subIndex}>
            <div className={"flex-item-between"}>
                <div>
                    <div className={"font_16 lineH_24"}>
                        {poItem.poCode}
                        {poItem.residueDays>0?<span className={"ml_4 labelDays"}>{Lang({id:"ShengYuNTian",default:`剩余 ${poItem.residueDays}天`,params:[poItem.residueDays]})}</span>:null}
                    </div>
                    {poItem.createTime? <div className={"black45 font_12"}>{getIntlYYMMDD(poItem.createTime,"HH:mm")}</div>:null}
                    <div className={"black66 flex-item-ver-center mt_4"}>
                        {/* 总计 */}
                        {/*箱*/}
                        <span className={"ri-archive-2-fill black33 font_16 mr_4"}></span><span>{Lang({id:"NXiang",default:"{0}箱",params:[isEmpty(poItem.totalQuantity)?"-":poItem.totalQuantity]})}</span>
                        {/*款*/}
                        {/*<span className="tit margin-left-5">{model.totalCount||'-'}{__getServerLanguage('Kuan')}</span>，*/}
                        {/* 体积 重量*/}
                        <span className={"ri-box-3-fill black33 font_16 ml_20 mr_4"}></span>{isEmpty(poItem.totalVolume)?"-":toFixed2(poItem.totalVolume,3)} m³
                        <span className={"ri-scales-2-fill black33 font_16 ml_20 mr_4"}></span>{isEmpty(poItem.totalGrossWeight)?"-":toFixed2(poItem.totalGrossWeight,3)} kg
                        {/* 中转城市名称 */}
                        <span className={"ri-hotel-fill black33 font_16 ml_20 mr_4"}></span>{poItem.transitCityName}{Lang({id:"CangKu",default:"仓库",})}
                    </div>
                </div>
                <span className={"font_16 fw_700 black45"}>{symbolMoneyUtil(poItem.totalPrice,poItem.currencySymbol)}</span>
            </div>
        </div>)
    }
    /*
    * 催收任务/提货提醒 已联系
    * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8318
    * */
    contacted(taskIds=[]){
        this.loading(true);
        DopIndexAction.postHttpAction("/service/mg/home/task/contacted",{
            taskIds:taskIds
        }).then(res=>this.getTodoRes(res.data)).catch(err=>this.getTodoRes(err));
    }
    getTodoRes(res){
        this.loading(false);
        const {success,valid,model={},} = res;
        if (success && valid) {
            message.success(Lang({id: 'CaoZuoChengGong', default: '操作成功'}));
            this.refreshData()
        }else if(res.message){
            message.warning(res.message);
        }else {
            message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
        }
    }
    refreshData(){
        this.onRefAutoFetchListChrld.handleFetch(1,false);
        if(this.props.refreshPage){
            this.props.refreshPage();
        }
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    // 列表
    onRefAutoFetchList = (ref) =>  this.onRefAutoFetchListChrld = ref;
    componentWillMount() {
    }
    componentDidMount() {
        if (this.props.onRef) this.props.onRef(this);
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
        if(this.showTimer)clearTimeout(this.showTimer)
    };
    render() {
        const {className,children,btnName,canOpen=false,type="" } = this.props;
        const {loading = false, visible=false,} = this.state;
        return (<Fragment>
            <div className={`${canOpen?"cursor-p":""}${className?" "+className:""}`} onClick={()=>this.showDrawer(canOpen?true:false)}>{children}</div>
            <Drawer title={<div className={"flex-item-ver-center lineH_27"}>
                                <span className={"font_18 fw_500"}>{btnName||Lang({id:"DingJinCuiShou",default:"定金催收"})}</span>
                        </div>}
                    width={1100}
                    rootClassName={"paymentCollectionDrawer"}
                    // maskClosable={false}
                    destroyOnClose={true}
                    onClose={()=>this.showDrawer(false)}
                    open={visible}>
                        <Spin spinning={loading}>
                            {/* 定金/尾款 催收待办提示 ||  type: "", // 显示 1:定金 * 2:尾款 * 3:提货 */}
                            <div className={"mb_12 alertMsg"}>
                                <Alert description={<div dangerouslySetInnerHTML={type==1?{__html:Lang({id:"DaiBanTiShiDingJinCuiShou",
                                        default:'<p>请联系这些客户并发出支付提醒，争取让他们及时支付定金。否则，<b>订单将在14天后被自动取消！</b></p><p>系统提醒规则：</p><p>第1次，下单日起第3天</p><p>第2次，下单日起第7天</p><p>第3次，下单日起第11天</p>'})}:{
                                            __html:Lang({id:"DaiBanTiShiWeiKuanCuiShou",
                                        default:'<p>请联系这些客户并发出支付提醒，争取让他们及时支付尾款并预约提货。<b>订单在仓库的免费停留时间只有30天！</b></p><p>系统提醒规则：</p><p>第1次，入库后第2天</p><p>第2次，入库后第10天</p><p>第3次，入库后第20天</p>'})}
                                }></div>} type="info" showIcon
                                       icon={<i className="ri-information-fill" style={{fontSize: "18px", marginTop: "10px", marginRight: "4px"}} />} />
                           </div>
                        <AutoFetchList onRef={this.onRefAutoFetchList}
                                       showTotal={false}
                                       precondition={{type:type}}
                                       fetchApi={type==1?'/service/mg/home/deposit/receivable/list':'/service/mg/home/balance/receivable/list'}
                                        // http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8329
                                        // http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8330
                                       renderList={(item,inx)=>this.renderOne(item,inx)} />
                        </Spin>
            </Drawer>
        </Fragment>);
    }
}